module.exports = __webpack_public_path__ + "static/media/team-4-800x800.f7a647c9.jpg";